// Version 3 är standard från 12 okt (Fahd 9 okt). ?ui=v1 och v1:s egna länkar (säljarlänken, mejlens
// Ekonomi-länkar, onboarding) startar dagens v1. Valet görs innan något laddas, så att v1:s Tailwind
// och v3:s CSS aldrig hamnar på samma sida. Se v2/entry.js.
import { wantsV2 } from './v2/entry';
import { systemFor, setFliksymbol } from './fliksymbol';
// Datumspärren för v1 och värdnamnen map.* och meeting.* ligger ovanpå wantsV2 (v2/app/version1.js).
import { valjVersion } from './v2/app/version1';
import { iUiTest, laddaUiSvar } from './v2/live/uitest';

const version = valjVersion(window.location, wantsV2(window.location));
setFliksymbol(version === 'v3' ? 'mm' : systemFor(window.location));

if (version === 'v3') {
  import('./v2/boot');
  if (iUiTest()) laddaUiSvar();   // UI-testets låtsassvar samtidigt som appen
  // Startsidan (Inkorg, också bakom ett öppet lead) hämtas samtidigt som appen, inte efter den (autoresearch 2026-10-23)
  if (/^(#\/?(inkorg|lead\/.*)?)?([?].*)?$/.test(window.location.hash)) import('./v2/pages/Inkorg/index.jsx');
} else {
  import('./boot-v1');
}

// Service workern (public/sw.js) gör MötesMaskinen installerbar och tar emot push. Den cachar ingenting.
// Bara i produktion: i utvecklingsläget skulle den ligga kvar och störa hot reload.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}
